<header>
    <div class="title">
        @if (showHistory) {
            <hive-button
                data-testid="copilot-side-panel-back"
                [icon]="faChevronLeft"
                emphasis="tertiary"
                size="smallest"
                title="Back"
                (click)="onBack()"
            />
            <hive-icon-component [icon]="faClockRotateLeft" size="small" />
            <span class="title-text">Chat History</span>
        } @else {
            <hive-icon-component [icon]="faSparkles" size="small" />
            <span class="title-text">AI CoPilot</span>
        }
    </div>
    <hive-button-group size="smallest" class="actions">
        <hive-button
            data-testid="copilot-side-panel-new-chat"
            [icon]="faPlus"
            emphasis="tertiary"
            title="Start a new chat"
            (click)="onNewChat()"
        />
        @if (!showHistory) {
            <hive-button
                data-testid="copilot-side-panel-history-toggle"
                [icon]="faClockRotateLeft"
                emphasis="tertiary"
                title="Chat history"
                (click)="toggleHistory()"
            />
            <hive-button
                data-testid="copilot-side-panel-expand"
                [icon]="faExpand"
                emphasis="tertiary"
                title="Expand to full page"
                (click)="expand.emit()"
            />
        }
        <hive-button
            data-testid="copilot-side-panel-close"
            [icon]="faXmark"
            emphasis="tertiary"
            title="Close"
            (click)="closePanel.emit()"
        />
    </hive-button-group>
</header>

<main class="body">
    @if (showHistory) {
        <copilot-conversation-panel
            [conversations]="allConversations"
            [activeConversation]="conversation"
            [showTitle]="false"
            (selectConversation)="onSelectConversation($event)"
            (deleteConversation)="deleteConversation.emit($event)"
            (newConversation)="onNewChat()"
        />
    } @else {
        @if (isNewConversation) {
            <div class="empty" data-testid="copilot-side-panel-empty">
                <!-- Page summary (when the summarize flag is on) is projected here; otherwise the
                     default prompt below is shown as ng-content fallback. -->
                <ng-content select="[copilotEmptyState]">
                    <p>{{ emptyPlaceholder }}</p>
                </ng-content>
            </div>
        } @else {
            <div class="messages" #messagesContainer>
                @for (msg of conversation.messages; track msg.index) {
                    <copilot-message
                        [message]="msg"
                        [conversationSessionId]="conversation.sessionId"
                        [isLatestResponse]="$last"
                        [isGenerating]="waitingForInputResponse && $last"
                        [isFeedbackLoading]="isFeedbackLoading(msg)"
                        [isFeedbackSuccessful]="isFeedbackSuccessful(msg)"
                        [isFeedbackFailed]="isFeedbackFailed(msg)"
                        [showFeedback]="showMessageFeedback(msg)"
                        (regenerate)="regenerateResponse.emit()"
                        (setVariation)="setVariation.emit($event)"
                        (submitFeedback)="submitFeedback.emit($event)"
                        (submitAdditionalFeedback)="submitAdditionalFeedback.emit($event)"
                        (closeAdditionalFeedback)="onCloseAdditionalFeedback($event, msg)"
                        (sendMessage)="submitMessage.emit($event)"
                    />
                }

                @let followUpQuestions = latestFollowUpQuestions;
                @if (followUpQuestions.length > 0) {
                    <div class="follow-ups" data-testid="copilot-side-panel-follow-ups">
                        <!-- Tracked by index, as on the full-page view: the list is short and fully
                             replaced each turn, and the model can repeat a question. -->
                        @for (question of followUpQuestions; track $index) {
                            <copilot-follow-up-chip [text]="question" (selectQuestion)="submitMessage.emit($event)" />
                        }
                    </div>
                }
            </div>
        }

        <ng-content select="[copilotPreInputContent]"></ng-content>

        <!-- Same indicator as the full-page view: a run paused in one surface must be
             visible and cancellable in the other. -->
        @if (triageActive) {
            <div class="triage-status" data-testid="copilot-side-panel-triage-status">
                <copilot-triage-status (exitTriage)="exitTriage.emit()" />
            </div>
        }

        <div class="input">
            <copilot-input-bar
                [isGenerating]="waitingForInputResponse"
                [placeholder]="inputPlaceholder"
                [suggestionsEnabled]="isNewConversation"
                [sessionId]="conversation?.sessionId ?? ''"
                (inputSubmit)="submitMessage.emit($event)"
                (stop)="stopMessage.emit()"
            />
        </div>
    }
</main>
